// extracted by mini-css-extract-plugin
export default {"container":"QG-z","innerContainer":"RG-z","multipleLines":"SG-z","heading":"TG-z","content":"UG-z","linkColor":"VG-z"};